var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostPerClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4701 17.1526L21.7972 14.8254C22.0607 14.5619 21.9538 14.1132 21.5998 13.9969L10.8884 10.476C10.4993 10.3481 10.1299 10.7167 10.2569 11.1061L13.7575 21.8377C13.8732 22.1924 14.3226 22.3 14.5864 22.0362L16.9117 19.711L19.7333 22.5326C20.1238 22.9231 20.757 22.9231 21.1475 22.5326L22.2917 21.3884C22.6822 20.9979 22.6822 20.3647 22.2917 19.9742L19.4701 17.1526Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2555 7.67938C13.393 6.18746 11.7804 5.18359 9.93321 5.18359C7.17793 5.18359 4.94434 7.41718 4.94434 10.1725C4.94434 12.0196 5.94821 13.6323 7.44014 14.4947",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4432 10.1713C18.4432 5.47126 14.633 1.66113 9.93301 1.66113C5.23298 1.66113 1.42285 5.47126 1.42285 10.1713C1.42285 14.8713 5.23298 18.6814 9.93301 18.6814",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostPerClick);
export default __webpack_public_path__ + "static/media/cost-per-click.2e5dcdab5d21354b107a51e470a0686d.svg";
export { ForwardRef as ReactComponent };